module.exports = __webpack_public_path__ + "fonts/fa-solid-900.9f3c8f80.woff2";